import React from 'react'
import { get, first } from 'lodash'
import RequirementLabel from '../../requirements/label'
import RequirementIcon from '../../requirements/icon'
import GradeLevelRequirement from './grade-level-requirement'

const DetailsModalRequirements = ({
    experience = {}
}) => {

    const courseRequirements = get(experience, 'requirements', [])

    const renderRequirementValue = (courseRequirement) => {
        const requirementValue = first(get(courseRequirement, 'requirementValues', []))
        if (!requirementValue) {
            return null
        }

        return (
            <span>
                : {requirementValue}
            </span>
        )
    }
    
    const renderRequirement = (courseRequirement) => {
        
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
                key={courseRequirement.id}
            >
                <RequirementIcon courseRequirement={courseRequirement} />
                <strong style={{ paddingLeft: '10px' }}><RequirementLabel courseRequirement={courseRequirement} /></strong>
                {renderRequirementValue(courseRequirement)}
            </div>
        )
    }

    return (
        <div>
            <GradeLevelRequirement experience={experience} />
            {courseRequirements.map(renderRequirement)}
        </div>
    )
}

export default DetailsModalRequirements